import { createActionGroup, props } from '@ngrx/store';

import { PermissionListDto, PermissionListSearchCriteria } from '../../models/permission-list.model';

export const PermissionActions = createActionGroup({
  source: 'Permission',
  events: {
    'Load Permissions': props<{ criteria: PermissionListSearchCriteria }>(),
    'Load Permissions Success': props<{
      permissions: PermissionListDto[];
      totalElements: number;
      totalPages: number;
    }>(),
    'Load Permissions Failure': props<{ error: string }>(),
    'Set Criteria': props<{ criteria: PermissionListSearchCriteria }>()
  }
});
